const map = {
	"./menu_admin.svg": 9224,
	"./menu_dashboard.svg": 5917,
	"./menu_ids.svg": 8999,
	"./menu_liveconnect.svg": 6765,
	"./menu_tenant.svg": 3531
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7992;